import React, { Component } from "react";
import { TableHeader } from "../../../businessSetting/deliveryRanges/nsc/TableHeader";
import { StatusOverviewRow } from "./StatusOverviewRow";
import "../../../../styles/sharedStyles.scss";

class StatusOverview extends Component {
  render() {
    return (
      <div className="pagePaddingTop">
        <div className="lineNumber pagePaddingLeft pagePaddingBottom">
          {this.props.t("PricingWrapper.statusOverview")}
        </div>
        <TableHeader
          headers={[
            this.props.t("PricingWrapper.model"),
            this.props.t("PricingWrapper.currentModel"),
            this.props.t("PricingWrapper.previousModel"),
          ]}
        />
        {this.props.vehicles.map((vehicle, index) => (
          <StatusOverviewRow {...this.props} key={index} vehicle={vehicle} />
        ))}
      </div>
    );
  }
}

export default StatusOverview;
